export default "__VITE_ASSET__CVQZpTco__"